import * as core from '../../../../../../../core'
import * as messageRole from '../message-role'

export const RESOURCE = {
  payload: {
    description: 'Message sent by an agent',
    enumId: core.dms.models.Enum.Id.from({
      partialId: messageRole.RESOURCE.payload.partialId,
    }),
    id: 'agent',
    name: 'Agent',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
